let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gO2Ws")).then(() => parcelRequire('9ncGU'));